import React from 'react'

export const AccentBar = ({ umbraco, vertical = 'top', className = '' }) => {
  const position = umbraco.AccentBarPosition || 'No accent bar'
  const color = umbraco.AccentBarColor ? `#${umbraco.AccentBarColor}` : '#B9E7FE'
  if (position === 'No accent bar') return null

  // Vertical position classes
  const verticalClass = vertical === 'bottom' ? 'bottom-0' : 'top-0'

  return (
    <div
      className={`absolute hidden custom-lg:block w-[120px] -z-10 ${verticalClass} ${position === 'right' ? 'right-0' : 'left-0'} ${className}`}
      style={{ backgroundColor: color }}
    />
  )
}
